export default "__VITE_ASSET__BT91AXTM__"